import { ReactElement } from 'react';
import { useFilterFields } from '../filter';
import { EntityMap } from '../types';
import { RowContainer } from './RowContainer';
import { filterRow } from './style.css';
import { BonusSummaryState } from './types';
import { Box } from '@ff-it/ui';
import { AddButton, RemoveButton } from 'components';
import { TextField } from '@ff-it/form';
import { coerceEmptyToNull } from 'utilities';

type FilterRowProps = {
  summary: BonusSummaryState;
  entities: EntityMap;
  clients?: string[];
  link?: () => void;
  unlink?: () => void;
  visibleKeys?: Set<string>;
};

export function FilterRow({ summary, entities, clients, link, unlink, visibleKeys }: FilterRowProps): ReactElement {
  const { client, outlet_or_service_category, provider, block } = useFilterFields(entities, clients);
  return (
    <RowContainer
      testId="filter-row"
      className={filterRow}
      visibleKeys={visibleKeys}
      client={client}
      supplier={
        <Box display="flex" flexDirection="row">
          {outlet_or_service_category}
          {provider}
        </Box>
      }
      block={block}
      invoices={
        <Box width="full">
          <TextField name="invoice" size="sm" placeholder="Invoice number" className="mb-0" {...coerceEmptyToNull} />
        </Box>
      }
      balance={<Box textSize="xl">{summary.available.toFixed(2)}</Box>}
      balanceControl={link ? <AddButton icon="circle-plus" onClick={link} /> : undefined}
      linked={
        <Box textSize="xl" fontWeight="bold" data-testid="applied">
          {summary.applied.toFixed(2)}
        </Box>
      }
      linkedControl={unlink ? <RemoveButton icon="circle-xmark" onClick={unlink} /> : undefined}
    />
  );
}
